// 9fbef606107a605d69c0edbcd8029e5d
import Styled from 'styled-components';

export default Styled.span`
  font-family: Nunito;
  font-size: 14px;
  font-weight: 800;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${(props) => props.theme.colors.BLACK.NORMAL};
  text-transform: uppercase;
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    font-size: 10px;
  }
  @media ${(props) => props.theme.mediaQuery.mediumOnly} {
    font-size: 12px;
  }
`;
